import { Pipe, PipeTransform } from '@angular/core';
import { LoggerService } from 'src/services/logger-services/logger.service';

@Pipe({
  name: 'totalMetadataItems'
})
export class TotalMetadataItemsPipe implements PipeTransform {
  private readonly TotalMetadataItemsPipeError = (error: any)=>
    `[TotalMetadataItemsPipe] ${JSON.stringify(error)}`;
  constructor(private readonly loggerService: LoggerService) {}
  transform(metadata: any[]): number {
    try{
    let total = 0;
    if (metadata && Array.isArray(metadata)) {
      metadata.forEach((dataGroup: any) => {
        if (dataGroup && typeof dataGroup === 'object') {
          total += Object.keys(dataGroup).filter(key => dataGroup[key] && typeof dataGroup[key] === 'object').length;
        }
      });
    }
    return total;
  }
  catch(error: any){
    this.loggerService.logError(this.TotalMetadataItemsPipeError(error), "transform")
    return 0;
  }
  }
}